import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import apiService from '../services/apiService';

const ManageSeller = () => {
  const [sellers, setSellers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    fetchSellers();
  }, []);

  const fetchSellers = async () => {
    try {
      setLoading(true);
      
      const data = await apiService.get('/seller-companies');
      setSellers(data);
      setError(null);
    } catch (err) {
      console.error('Error fetching sellers:', err);
      setError('Failed to load sellers. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  const handleSellerClick = (sellerId) => {
    navigate(`/sellers/${sellerId}`);
  };

  if (loading) {
    return (
      <div className="manage-properties">
        <div className="page-header">
          <h1>Manage Sellers</h1>
        </div>
        <div className="loading-state">
          <p>Loading sellers...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="manage-properties">
        <div className="page-header">
          <h1>Manage Sellers</h1>
        </div>
        <div className="error-state">
          <p>{error}</p>
          <button onClick={fetchSellers} className="retry-button">
            Try Again
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="manage-properties">
      <div className="page-header">
        <h1>Manage Sellers</h1>
      </div>

      <div className="properties-table">
        <table>
          <thead>
            <tr>
              <th>ID</th>
              <th>Company Name</th>
              <th>Contact Person</th>
              <th>Email</th>
              <th>Phone</th>
              <th>Description</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {sellers.map((seller) => (
              <tr key={seller.id}>
                <td>
                  <strong>{seller.id}</strong>
                </td>
                <td>
                  <a 
                    href="#"
                    className="property-link"
                    onClick={(e) => {
                      e.preventDefault();
                      handleSellerClick(seller.id);
                    }}
                    title="Click to edit seller details"
                  >
                    {seller.companyName}
                  </a>
                </td>
                <td>{seller.contactPerson}</td>
                <td>{seller.emailAddress}</td>
                <td>{seller.contactNumber}</td>
                <td>
                  <span className="description-text">
                    {seller.description ? 
                      (seller.description.length > 50 
                        ? `${seller.description.substring(0, 50)}...` 
                        : seller.description
                      ) 
                      : 'No description'
                    }
                  </span>
                </td>
                <td>
                  <span className={`status-badge ${seller.isActive ? 'active' : 'inactive'}`}>
                    {seller.isActive ? 'Active' : 'Inactive'}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ManageSeller;
